/**
 * Reverse geocodes coordinates (lat, lng) using the Nominatim (OpenStreetMap) API.
 * 
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @returns {Promise<{city: string, location: string, country: string}>}
 */
export const reverseGeocode = async (lat, lng) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`,
      {
        headers: {
          "Accept-Language": "en",
          "User-Agent": "CentriaLanding/1.0"
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Geocoding error: ${response.statusText}`);
    }

    const data = await response.json();
    const address = data.address || {};

    // Most specific → least specific place name
    const city =
      address.city ||
      address.town ||
      address.village ||
      address.suburb ||
      null;

    // County / province / state fallback
    const county =
      address.county ||
      address.state_district ||
      address.state ||
      address.region ||
      null;

    const country = address.country || null;
    const location = data.display_name || "Unknown Location";

    return {
      city,
      county,
      country,
      location,
    };
  } catch (error) {
    console.error("Failed to reverse geocode:", error);
    return {
      city: null,
      county: null,
      country: null,
      location: "N/A",
    };
  }
};
